import React, { Component, Fragment } from 'react';

import { TabBox } from 'components/tabs';
import { FileService } from 'modules/file';
import { FileUploadLimitModal } from 'modules/file/components/FileUploadModals';
import { isVideo } from 'modules/file/helpers';
import PropTypes from 'prop-types';

import EmbedMedia from './EmbedMedia';
import TabImage from './TabImage';
import TabVideo from './TabVideo';

import { deleteUploadFromAnyEntity } from '@hotmart/club-files-ui';

export default class TabBoxMedia extends Component {
  state = {
    showReplaceModal: false,
    callbackFunc: null,
    params: null
  };

  get item() {
    return this.props.items[0];
  }

  get style() {
    const style = {};

    if (!this.item) {
      style.display = 'none';
    }
  }

  static propTypes = {
    items: PropTypes.array,
    entityType: PropTypes.string,
    mediaUrl: PropTypes.string,
    selected: PropTypes.number,
    setMediaUrl: PropTypes.func,
    onItemsChange: PropTypes.func,
    onItemsUpdateStatus: PropTypes.func,
    onTabChange: PropTypes.func,
    multiple: PropTypes.bool,
    setCentralError: PropTypes.func,
    match: PropTypes.object
  };

  static defaultProps = {
    multiple: false
  };

  beforeSend = (callbackFunc, param) => {
    const { items, mediaUrl } = this.props;

    // Already have a media ou embedded URL
    if (items.length > 0 || mediaUrl) {
      // Show confirmation modal and save callback func and param to be executed
      this.setState({ showReplaceModal: true, callbackFunc, param });
    } else {
      callbackFunc(param);
    }
  };

  executeSavedFunc = () => {
    const { items = [] } = this.props;
    const { callbackFunc, param } = this.state;
    const item = items[0];
    const shouldDeleteItem = item && item.entityInfo;

    shouldDeleteItem && deleteUploadFromAnyEntity(item.id, item.entityInfo);
    callbackFunc(param);
  };

  closeModal = () => {
    this.setState({ showReplaceModal: false });
  };

  splitMedias = () => {
    const { items } = this.props;
    const splittedMedias = items.reduce(
      (output, media) => {
        if (isVideo(media)) {
          output.videos.push(media);
        } else {
          output.images.push(media);
        }

        return output;
      },
      { videos: [], images: [] }
    );

    return splittedMedias;
  };

  render() {
    const {
      mediaUrl,
      selected,
      setMediaUrl,
      entityType,
      onTabChange,
      onItemsChange,
      onItemsUpdateStatus,
      multiple,
      setCentralError
    } = this.props;

    const { showReplaceModal } = this.state;
    const { videos, images } = this.splitMedias();

    return (
      <Fragment>
        <TabBox
          onTabChange={onTabChange}
          selected={selected}
          style={this.style}
        >
          <TabVideo
            title="files.tabs.send_video"
            entityType={entityType}
            medias={videos}
            onItemsChange={onItemsChange}
            onItemsUpdateStatus={onItemsUpdateStatus}
            beforeSend={this.beforeSend}
            multiple={multiple}
            setCentralError={setCentralError}
            onCancelUpload={FileService.delete}
          />

          <EmbedMedia
            title="files.tabs.embed_url"
            mediaUrl={mediaUrl}
            setMediaUrl={setMediaUrl}
            className="min-height"
            beforeSend={this.beforeSend}
          />

          <TabImage
            title="files.tabs.send_image"
            entityType={entityType}
            medias={images}
            onItemsChange={onItemsChange}
            onItemsUpdateStatus={onItemsUpdateStatus}
            beforeSend={this.beforeSend}
            multiple={multiple}
            setCentralError={setCentralError}
          />
        </TabBox>

        {showReplaceModal && (
          <FileUploadLimitModal
            onConfirm={this.executeSavedFunc}
            onClose={this.closeModal}
          />
        )}
      </Fragment>
    );
  }
}
